import React from 'react'
import { Routes, Route, Navigate } from 'react-router'
import { MFASelectionPage, PasswordVerificationPage, VerificationCodePage } from '.'

export const MFASettingsPages = (): JSX.Element | null => {
  return (
    <Routes>
      <Route path='/' element={<MFASelectionPage />} />
      <Route path='/verify-password' element={<PasswordVerificationPage />} />
      <Route path='/verify-code/:preferredFactor' element={<VerificationCodePage />} />
      <Route path='*' element={<Navigate to='/settings/mfa' />} />
    </Routes>
  )
}
